export default __webpack_public_path__ + "static/media/doc.60324bd5.png";